import React, { Component } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { translate  } from 'react-i18next';
import {
  Alert, Row, Col, Button, FormGroup, Label,
  InputGroup, InputGroupAddon, ModalHeader, ModalBody, Modal, ModalFooter, Input,
} from 'reactstrap';
import Settings from '../../Store/Settings';
import TextField from '../../Components/Form/TextField';
import Voucher from '../../Store/Voucher';
import { withRouter } from 'react-router';

@observer
class GiftcardCheck extends Component {
  @observable giftcode = '';
  @observable giftcodeText = '';

  constructor(props) {
    super(props);
    this.handleCheckCertificate = this.handleCheckCertificate.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
  }

  async handleCheckCertificate(e) {
    e.preventDefault();
    const { t } = this.props;

    const voucher = await Voucher.get(this.giftcode);
    if (voucher) {
      if (voucher.aircraft_offer.id) {
        this.props.router.push(
          `/offer/${voucher.aircraft_offer.flight_offer.id}?aircraft=${voucher.aircraft_offer.id}&passengers=${voucher.offer_passenger_count}&giftcode=${voucher.code}`
        );
        this.giftcode = ''; // Clear after navigation
      } else {
        this.giftcodeText = t('Remaining value is {{value}} {{currency_code}}', {
          value: voucher.value.toFixed(2),
          currency_code: voucher.currency_code
        });
      }
    } else {
      this.giftcodeText = t('Invalid voucher');
    }
  }

  handleModalClose() {
    this.giftcodeText = null;
  }

  renderInput = (inputProps) => {
    const { t } = this.props;
    return (
      <InputGroup>
        <Input {...inputProps} />
        <Button color="success" onClick={this.handleCheckCertificate}>
          {t('Check')}
        </Button>
      </InputGroup>
    );
  };

  render() {
    const { t } = this.props;
    return (
      <div>
        <Row className="giftcard-container">
          <Col lg={12}>
            <h1>1. {t('Gift card check')}</h1>
            <div className="selects-container">
              <Row style={{width:'100%', margin:0}}>
                <Col md={10} className='p-0 pr-md-3'>
                  <FormGroup style={{width:'100%'}} >
                    <Label>{t('Enter Gift Certificate Code')}</Label>
                    <Input
                      name="giftcode"
                      placeholder={t('Enter gift code')}
                      onChange={e => this.giftcode = e.target.value}
                      value={this.giftcode}
                    />
                  </FormGroup>
                </Col>
                <Col md={2} className='p-0'>
                  <FormGroup>
                    <Label>&nbsp;</Label>
                    <Button block color="secondary" onClick={this.handleCheckCertificate}>
                      {t('Check')}
                    </Button>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <Modal isOpen={!!this.giftcodeText}>
          <ModalBody>
            {this.giftcodeText}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.handleModalClose}>
              {t('Schliessen & Weiter')}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default withRouter(translate ()(GiftcardCheck));



// WEBPACK FOOTER //
// ./src/App/Components/Giftcards/GiftcardCheck.js